/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";

import { BlackButton } from "../BlackButton";
import { moreButtonStyle, moreButtonWrapperStyle } from "./styles";

import type { Props } from "./props";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const ShowMoreButton: FcWithoutChildren<Props> = (props) => {
  const { isShown, onClickShowMore } = props;
  const { t } = useI18n();

  if (!isShown) return null;

  return (
    <div css={moreButtonWrapperStyle}>
      <BlackButton css={moreButtonStyle} onClick={onClickShowMore}>
        {t("settlementHistory.moreRead")}
      </BlackButton>
    </div>
  );
};
